@if (maxLength) {
  <span>{{ value ? value.length : 0 }}</span>
  <span>/</span>
  <span>{{ maxLength }}</span>
}
